import React from "react";
import { Upload, Video, ClipboardList, Users } from "lucide-react";

export default function Instructor() {
  return (
    <main className="pt-24 pb-24 bg-[#F8F9FA] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-satoshi font-black text-3xl text-[#0A192F]">Instructor Console</h1>
        <p className="text-slate-500 font-inter">Manage your lessons, quizzes and student grading.</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { i: Video, t: "Upload Lesson", d: "Add a new video lesson" },
            { i: ClipboardList, t: "Create Quiz", d: "Build a quick assessment" },
            { i: Users, t: "Grade Students", d: "Review assignments" },
            { i: Upload, t: "Resources", d: "Upload PDFs & slides" },
          ].map((a, i) => (
            <button key={i} className="ali-card p-6 text-left ali-lift" data-testid={`instr-${a.t}`}>
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#FF6B35] to-[#E85D2A] text-white grid place-items-center mb-4"><a.i className="w-5 h-5" /></div>
              <p className="font-satoshi font-bold text-[#0A192F]">{a.t}</p>
              <p className="text-sm text-slate-500 font-inter">{a.d}</p>
            </button>
          ))}
        </div>

        <div className="mt-10 ali-card p-8 text-center">
          <p className="font-satoshi font-bold text-xl text-[#0A192F]">Lesson Upload</p>
          <p className="mt-2 text-slate-500 font-inter">Drag & drop a video or click to browse — uploads coming in the next iteration.</p>
          <div className="mt-6 border-2 border-dashed border-slate-200 rounded-3xl p-12">
            <Upload className="w-12 h-12 text-[#FF6B35] mx-auto" />
            <p className="mt-3 font-poppins text-slate-500">Drop video file here</p>
          </div>
        </div>
      </div>
    </main>
  );
}
